import { render, staticRenderFns } from "./AdminSettings.vue?vue&type=template&id=76a66d8c&scoped=true&"
import script from "./AdminSettings.vue?vue&type=script&lang=js&"
export * from "./AdminSettings.vue?vue&type=script&lang=js&"
import style0 from "./AdminSettings.vue?vue&type=style&index=0&id=76a66d8c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76a66d8c",
  null
  
)

export default component.exports